import { render, staticRenderFns } from "./color-menu.vue?vue&type=template&id=bc98ef16"
import script from "./color-menu.vue?vue&type=script&lang=js"
export * from "./color-menu.vue?vue&type=script&lang=js"
import style0 from "./color-menu.vue?vue&type=style&index=0&id=bc98ef16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports